<template>
  <div class="home-title">
    <h3>{{ title }}</h3>
    <div class="line" v-if="titleEn"></div>
    <p>{{ titleEn }}</p>

    <div class="extra">
      <slot name="extra"/>
    </div>

  </div>
</template>
<script>
export default {
  props: [
    'title',
    'titleEn'
  ],
  data () {
    return {
    }
  },
  computed: {
    speakers () {
      return null
    }
  },
  updated () {
  },
  mounted () {
  },
  beforeDestroy () {
  },
  methods: {
  }
}
</script>
<style scoped lang="sass">

.home-title
  padding-bottom: 60px
  +mobile
    padding-bottom: 35px
  h3
    margin: 0 auto!important
    text-align: center
    font-size: 28px
    color: var(--primary-color)
  .line
    width: 55px
    border-bottom: 2px solid var(--primary-color)
    margin: 0 auto
    padding-top: 3px
  p
    text-align: center
    padding-top: 5px
    font-size: 17px
    font-weight: 400
    color: #777
  & .extra
    margin-top: 8px
  &.light
    h3
      color: $white
      opacity: 0.85
    .line
      border-bottom: 2px solid var(--primary-color)
    p
      color: $grey-lighter
      opacity: 0.8
</style>
